// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatSourcePickerCardLabel-moduledescription__I_dOQ";
var _2 = "GretaAIChatSourcePickerCardLabel-moduleiconTile__wqdaY";
var _3 = "GretaAIChatSourcePickerCardLabel-modulenewBadge__z_wlq Status-modulestatus__sQfjb Tag-moduleTag__FLr9H";
var _4 = "GretaAIChatSourcePickerCardLabel-moduleselected__ZkIkW";
var _5 = "GretaAIChatSourcePickerCardLabel-moduletext__I6xg4";
var _6 = "GretaAIChatSourcePickerCardLabel-moduletitle__L7pBm";
export { _1 as "description", _2 as "iconTile", _3 as "newBadge", _4 as "selected", _5 as "text", _6 as "title" }
